import MarkdownResponse from "./MarkdownResponse/MarkdownResponse";
import Support from "./Cosmic/Support";
import { Stack, StackItem } from "@fluentui/react";
import FeedbackModal from "./FeedbackModal";
import { FeedbackStatus } from "../../constants/SettingConstant";

const keywords = ["I'm not aware of the answer"];

const createResultBlob = async (fileDownloadData) => { // AI
	const byteCharacters = atob(fileDownloadData.base64Content);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i); }
	const byteArray = new Uint8Array(byteNumbers);
	if (!fileDownloadData.contentEncoding) {
		return new Blob([byteArray], { type: fileDownloadData.contentType });
	}

	if (fileDownloadData.contentEncoding.toLowerCase() !== "gzip") {
		throw new Error(`Unsupported result compression: ${fileDownloadData.contentEncoding}`);
	}
	if (!window.DecompressionStream) {
		throw new Error("This browser does not support compressed result downloads.");
	}

	const decompressedStream = new Blob([byteArray])
		.stream()
		.pipeThrough(new window.DecompressionStream("gzip"));
	const decompressedBytes = await new Response(decompressedStream).arrayBuffer();
	return new Blob([decompressedBytes], { type: fileDownloadData.contentType });
}; // AI

export const appendList = (message, name, initials, c, showCosmicButton, showFeedbackOptions, suggestedQuestions, isSupportAssistanceRequired, feedbackStatus, fileDownloadData ) => { // AI
	const isMatch = keywords.some((keyword) => message.toLowerCase().includes(keyword.toLowerCase())) || isSupportAssistanceRequired;
	const cosmicPresent = showCosmicButton && isMatch;
	return {
		key: c,
		index:0,
		cosmicPresentKey: cosmicPresent,
		suggestedQuestions: suggestedQuestions,
		feedbackPresentKey: showFeedbackOptions,
		fileDownloadData: fileDownloadData || null, // AI
		// activityDescription: [
		// 	<span key={1} className="nameText">
		// 		{" "}
		// 		{name}
		// 	</span>
		// ],
		activityPersonas: [{ imageInitials: "", text: initials, initialsColor: "" }],
		commentText: message,
		comments: [
			<span key={1} className="messageText">
				<MarkdownResponse  content={message} />
				<Stack horizontal className="response-footer-stack">
					<StackItem className="response-footer-left">{showCosmicButton && isMatch && <Support></Support>}
						{fileDownloadData && <button className="csv-download-button" onClick={async () => { // AI
							try {
								const blob = await createResultBlob(fileDownloadData); // AI
								const url = window.URL.createObjectURL(blob);
								const link = document.createElement("a");
								link.href = url;
								const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-"); // AI
								const extensionIndex = fileDownloadData.fileName.lastIndexOf("."); // AI
								link.download = extensionIndex > 0
									? `${fileDownloadData.fileName.substring(0, extensionIndex)}-${timestamp}${fileDownloadData.fileName.substring(extensionIndex)}`
									: `${fileDownloadData.fileName}-${timestamp}`; // AI
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
								window.URL.revokeObjectURL(url);
							} catch (e) { console.error("Result download failed:", e); } // AI
						}}><i className="ms-Icon ms-Icon--Download" aria-hidden="true"></i> Download Results</button>}{/* AI */}
					</StackItem>
					<StackItem>{(showFeedbackOptions || feedbackStatus == FeedbackStatus.PositveFeedback || feedbackStatus == FeedbackStatus.NegativeFeedback) && <FeedbackModal feedbackStatus={feedbackStatus} />}</StackItem>
				</Stack>
			</span>
		]
		// timeStamp: getTimeStamp()
	};
};
